import { Component, EventEmitter, OnInit, Output } from '@angular/core';

interface menu {
  name: string,
  class: string,
  hrf?: string,
  download?: string,
  subMenu?: string[]
}
@Component({
  selector: 'web-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', '../web-request.scss']
})
export class HeaderComponent implements OnInit {
  activeNavLink: String = '';
  menuSection: boolean = false;
  aboutMenuSection: boolean = false;
  productMenuSection: boolean = false;
  resourcesMenuSection: boolean = false;
  enableSub: boolean = false;
  Menus: menu[] = [
    // {
    //   name: "Home",
    //   class: "home"
    // },
    {
      name: "About Us",
      class: "about_us",
      hrf: "https://arconcontainer.com/about-us",
      subMenu: ['Vision,Mission & Values', 'Management', 'Initiatives', 'Life At ARCON']
    },
    {
      name: "Dry Containers",
      class: "prod_serv",
      hrf: "https://arconcontainer.com/container",
      subMenu: ['Standard Boxes', 'Our Services']
    },
    {
      name: "Specials",
      class: "prod_serv",
      hrf: "https://arconcontainer.com/specials",
      subMenu: ['Special Boxes', 'Our Services']
    },
    {
      name: "Tanks",
      class: "prod_serv",
      hrf: "https://arconcontainer.com/tanks",
      subMenu: ['Our Fleet', 'Our Services']
    },
    {
      name: "Resources",
      class: "resources",
      hrf: "https://arconcontainer.com/resources/articles",
      subMenu: ['Articles']
    },
    {
      name: "Contact Us",
      class: "contact_us",
      hrf: "https://arconcontainer.com/contact-us"
    },
  ]
  @Output() showMenu: EventEmitter<any> = new EventEmitter();

  mobileViewManageDropDownList(sectionName: string) {
    switch (sectionName) {
      case 'menuSection':
        this.menuSection = !this.menuSection;
        this.aboutMenuSection = false
        this.productMenuSection = false
        this.resourcesMenuSection = false
        break;
      case 'aboutMenuSection':
        this.aboutMenuSection = !this.aboutMenuSection;
        this.productMenuSection = false
        this.resourcesMenuSection = false
        break;
      case 'productMenuSection':
        this.productMenuSection = !this.productMenuSection;
        this.aboutMenuSection = false
        this.resourcesMenuSection = false
        break;
      case 'resourcesMenuSection':
        this.resourcesMenuSection = !this.resourcesMenuSection;
        this.aboutMenuSection = false
        this.productMenuSection = false
        break;
      default:
        break;
    }
    this.showMenu.emit();
  }

  openSub(i: any) {
    // this.enableSub = !this.enableSub;
    // console.log(i)
    var element = document.getElementById(i.class);
    element!.classList.toggle("selectedMenu");

  }
  constructor() { }

  ngOnInit(): void {
  }

}
